import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { getMoodColor, getEmotionLabel } from '../../utils/colors';

interface DroppableCellProps {
    x: number;
    y: number;
    children?: React.ReactNode;
}

export const DroppableCell: React.FC<DroppableCellProps> = ({ x, y, children }) => {
    const { isOver, setNodeRef } = useDroppable({
        id: `cell-${x}-${y}`,
        data: { x, y },
    });

    const backgroundColor = getMoodColor(x, y);
    const label = getEmotionLabel(x, y);

    return (
        <div
            ref={setNodeRef}
            className={`mood-cell relative w-full h-full min-h-[40px] border border-border-base flex items-center justify-center transition-colors ${isOver ? 'ring-2 ring-white ring-inset z-10' : ''
                }`}
            style={{ backgroundColor }}
            title={label}
        >
            <span className="absolute bottom-1 right-1 text-[10px] uppercase font-bold text-black/30 pointer-events-none select-none">
                {label}
            </span>
            {children}
        </div>
    );
};
